<script lang="ts">
    import { APIHelper } from "../../code/APIHelper";
    import DBG from "../../code/DBG";

    import Helpers from "../../code/Helpers";
    import ContactSupport from "../Generic/ContactSupport.svelte";

    let status = "&nbsp;";

    function logOut() {
        DBG.log("IdentityLogout - logOut");
       
        APIHelper.logOut().then(() => {
            DBG.log("IdentityLogout - logOut DONE");
            status = "You are now signed out";
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        });
    }
    function submit() {
        status = "Sending...";
        logOut();
    }
 
</script>

<div>
    <button type="button" class="btn btn-primary" on:click={submit}
        >Log out</button
    >
    <div class="status">
        {@html status}
    </div>
</div>
